/**
 * @file dataSources.js
 * @desc Provides the dataSources module, which is responsible for loading up
 * common data sources like the report list and org list.
 * @author Geoffrey Pursell
 */


define('commonDataSources',["jquery", "underscore", "underscore.string", "backbone",
		"cardboard/models", "cardboard/collections", "models"],
function ($, _, _s, Backbone,
		  CardboardModels, CardboardCollections, SLEDSModels) {
	
	console.log("MODULE: datasources");



	/**
	 * @exports dataSources
	 * @desc contains specific data model objects that go get specific
	 * data.
	 */

	return {
		// REPORTS
		reportInfo: new SLEDSModels.SLEDSReports({}, {
			url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_reports_get.fex",
			// url: "/data/mocks/reportList.json",
			
			model: CardboardModels.Report,
			comparator: "sort"
		}),

		// ORG LIST
	//	entities: new SLEDSModels.SLEDSOrgList({}, {
			// url: "/data/mocks/orgList.json"
			// url: "/data/mocks/orgListWithArrays.json"
			// url: "/mocks/foo"
//			url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_filter_hsgrad_orgid.fex"
//		}),

		orgDetail: {
			modelType: SLEDSModels.SLEDScontactInformation,
			url: "/ibi_apps/WFServlet?IBIF_ex=sledsws_getdata_contact_information.fex",
			enabled: true
		},

		/*dynamicText: new CardboardCollections.TextContent({
			url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_cms_content.fex"
		}),*/


		// FILTERS
		// filters: new CardboardCollections.Collection([], {
		// 	url: "/data/mocks/filters.json"
		// }),

		// GENERIC CATEGORY LIST

		/** set up the (empty, at first) model that will hold the generic subjects
		 * menu data source, which will be populated with a version of the generic
		 * subjects list filtered for the selected report
		 * @namespace */
		Derivative: {
			filteredGenericSubjects: new CardboardModels.DerivativeFilterData([]),
			filteredGenericCategories: new CardboardCollections.DerivativeCollectionData([])
		}
	};
});

